import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import {Box, MainHeadingContainer, MainHeading, BoxContent, NoData} from '../../StyledComponents';


/**
* Styled components
*/
const ListViewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
/*
const MainHeadingContainer = styled.div`
  background-color: #0C0E16;
  margin: -20px -20px 10px -20px;
  padding: 12px 20px;
`;

const MainHeading = styled.h1`
  text-transform: uppercase;
  margin-bottom: 0px;
  font-size: 14px !important;
`;
*/
const TableContainer = styled.div`
  padding-left: 5%;
  padding-right: 5%;
  padding-bottom: 5px;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  @media only screen and (max-width: 991px) {
    margin-top: 15px;
  }

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }

  ${props => props.showReportDetails && css`
    padding-left: 0;
    padding-right: 0;
  `}
`;

const TableList = styled.table`

  border-collapse: collapse;
  width: 100%;

  th {
    background-color: rgba(7, 14, 19, 0.5);
    color: #dbdcdd;
    padding: 10px 20px
    text-transform: uppercase;
  }

  td {
    padding: 6px 20px;
  }

  tbody tr:nth-child(odd) {
    background-color: rgba(16, 23, 29, 0.5);
    color: #dbdcdd;
  }

  tbody tr:nth-child(even) {
    background-color: rgba(7, 14, 19, 0.5);
    color: #dbdcdd;
  }

  ${props => props.showReportDetails && css`
    th {
      background-color: transparent;
      border-top: 1px solid #777;
      border-bottom: 1px solid #777;
      color: #fff;
      text-transform: capitalize;
      padding: 5px 10px;
    }

    tbody tr:nth-child(odd) {
      background-color: transparent;
    }

    tbody tr:nth-child(even) {
      background-color: transparent;
    }

    td {
      padding: 4px 10px;
    }

  `}
`;

const ListReportBox = styled.div`
  h2 {
    border-top: 1px solid #777;
    border-bottom: 1px solid #777;
    margin-top: 2px;
    padding: 7px 10px;
  }

  span {
    text-transform: initial;
    margin-right: 10px;
    border-radius: 10px;
    padding-right: 8px;
    padding-left: 8px;
    display: inline-block;
    margin-top: 5px;
    margin-bottom: 5px;
    font-weight: 500;
  }
`;


class ListView extends Component {
  renderTableHead(data) {
    let headers = data.headers;
    return (
      <thead>
        <tr>
        {
          _.map(headers, (headerValue, index) => {
            return(
              <th className="normal-font-size" key={`${headerValue}-${index}`}>{headerValue}</th>
            );
          })
        }
        </tr>
      </thead>
    )
  }



  renderTableBody(data) {
    let rows = data.rows;
    let rowsToLoop = [];
    rowsToLoop = this.props.tableRows ? rows.slice(0, this.props.tableRows) : rows.slice()

    return (
      <tbody>
        {
          _.map(rowsToLoop, (row, index) => {
            return(
              <tr key={`${row[0]}-${index}`}>
                <td className="normal-font-size">{row[0]}</td>
                <td className="normal-font-size">{row[1]}</td>
              </tr>
            );
          })
        }
      </tbody>
    )

  }

  renderReportDetails(data) {
    return(
      <ListReportBox>
      <h2 className="normal-font-size">Missing</h2>
      {_.map(data, (value, index) => {
          return(
            <span className="report-tag small-font-size" key={`listreport-${value}-${index}`}>{value.charAt(0).toUpperCase() + value.slice(1)}</span>
          );
        })
      }
      </ListReportBox>
    )
  }


  render() {
      const { data, dataReport, reportMode, printBreak } = this.props;


      const placeholderData = {
        "type":"table",
        "title":"Sentiment (top 5)",
        "description":"",
        "values": {
            "headers": ["Header 1", "Header 2"],
            "rows":[
                ["List item 1", 1322],
                ["List item 2", 126],
                ["List item 3", 12]
            ]
        }
      };

      const disabled = !data;
      const _data = data || placeholderData;
      return (
        <Box className={printBreak ? 'print-page-break-after' : ''}>
          <ListViewContainer>
            <MainHeadingContainer>
              <MainHeading className="normal-font-size">{disabled ? (this.props.title || _data.title):_data.title}</MainHeading>
            </MainHeadingContainer>
            <BoxContent disabled={disabled}>
            {_data && (
              <TableContainer showReportDetails={reportMode}>
                <TableList showReportDetails={reportMode}>
                  {this.renderTableHead(_data.values)}
                  {this.renderTableBody(_data.values)}
                </TableList>
              </TableContainer>
            )}
            {reportMode && _data && dataReport ? this.renderReportDetails(dataReport) : ''}
            </BoxContent>
            {disabled && <NoData/>}
          </ListViewContainer>
        </Box>
      );

  }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid
    };
}

export default connect(mapStateToProps)(ListView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/ListView.js